import { amplitudeLib } from 'freedom-shared';
import { airflow } from '@aviata/platform-client';
import { providerClassLib } from 'shared';

import type { SelectFareFamilyParams } from '../analytics';
import { extractAnalyticsDataLib } from '../analytics-data-extraction';
import { getSearchModeFromQuery, getMainPageVariant } from './main-page';

export const selectFareFamily = (params: SelectFareFamilyParams) => {
  const ffIndex = params.isBaseFare ? 1 : params.choice.id;

  // Extract first 4 options (baggage, hand_luggage, refund, exchange) for non-base tariffs
  const options: string[] = [];
  if (!params.isBaseFare && params.descriptions) {
    const relevantTypes = ['baggage', 'hand_luggage', 'refund', 'exchange'];
    const filteredDescriptions = params.descriptions
      .filter(desc => relevantTypes.includes(desc.type))
      .slice(0, 4);
    options.push(...filteredDescriptions.map(desc => desc.name));
  }

  let searchType: string | undefined;
  if (params.searchQuery) {
    const searchParams = airflow.utils.parseQuery(params.searchQuery);
    searchType = getSearchModeFromQuery(searchParams);
  }

  const eventProperties: Record<string, unknown> = {
    ff_name: params.fareFamilyName,
    ff_index: ffIndex,
    base: params.isBaseFare,
    source: params.source,
    travel_type: params.isDomestic ? 'D' : 'I',
    connect_type: extractAnalyticsDataLib.getConnectType(params.connectType),
    search_mode: searchType,
    is_charter: providerClassLib.isFunSun(params.providerClass ?? ''),
    main_page_variant: getMainPageVariant(),
  };

  if (options.length > 0) {
    eventProperties.options = options;
  }

  amplitudeLib.logEvent('avfree_ff_choose_click', eventProperties);
};

export const continueFareFamily = ({
  isFareFamiliesFlexible,
  isError,
}: {
  isFareFamiliesFlexible: boolean;
  isError: boolean;
}) => {
  amplitudeLib.logEvent('avfree_ff_continue_click', {
    is_fare_families_flexible: isFareFamiliesFlexible,
    has_error: isError,
    main_page_variant: getMainPageVariant(),
  });
};

export const fareFamilyHintClick = (hintType: string) => {
  amplitudeLib.logEvent('avfree_ff_hint_click', {
    hint_type: hintType,
    main_page_variant: getMainPageVariant(),
  });
};
